import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import NationalityForm from '../components/NationalityForm';
import { useNationalityDetails } from '../hooks/useNationalityDetails';
import { useUpdateNationality } from '../hooks/useNationalityMutations';

export default function NationalityEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading: loadingDetails } = useNationalityDetails(id);
  const mutation = useUpdateNationality();

  const handleSubmit = (formData: any) => {
    (mutation.mutate as any)({ id, data: formData }, { onSuccess: () => navigate('/nationalities') });
  };

  if (loadingDetails) return <Spin style={{ display: 'block', margin: '80px auto' }} />;

  return (
    <div>
      <PageHeader back title={t('nationalities.editTitle')} subtitle={`${t('common.editing')}: ${data?.countryNameEn || ''}`} />
      <Card>
        <NationalityForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
